import { useState } from 'react';

import CartRepository from '~repositories/CartRepository/CartRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import UpdateCartUseCase from '~use-cases/UpdateCartUseCase';
import FetchedCartInfoUseCase from '~use-cases/FetchedCartInfoUseCase';

export const useCart = (baseSkuId?: number | string) => {
    const { cart }: CartRepository = diContainer.get(serviceNames.cartRepository);
    const { pricedSkusQty } = cart;
    const [isLoading, setIsLoading] = useState(false);

    const fetchCart = () => {
        setIsLoading(true);
        new FetchedCartInfoUseCase().execute().finally(() => {
            setIsLoading(false);
        });
    };

    const addToCart = async () => {
        setIsLoading(true);
        await new UpdateCartUseCase({ skus: [baseSkuId?.toString() || ''], quantity: 1 }).execute();
        setIsLoading(false);
    };

    const removeFromCart = async () => {
        setIsLoading(true);
        await new UpdateCartUseCase({ skus: [baseSkuId?.toString() || ''], quantity: 0 }).execute();
        setIsLoading(false);
    };

    const isInCart = () => cart.cartItems.find(({ skuId }) => skuId === baseSkuId);

    return { addToCart, removeFromCart, isInCart, fetchCart, isLoading, pricedSkusQty };
};
